var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Segments } from "apparatus/library/common";
import { CompoundPath, Group, Path } from "paper";
import { staticImplements } from "types";
let Sieve = class Sieve {
    render({ size }) {
        const radius = size / 2;
        const height = radius * 0.3 + 5;
        const graphic = new Group();
        const walls = new CompoundPath({});
        walls.moveTo(P(-radius, -height));
        walls.lineBy(P(0, height));
        walls.moveTo(P(radius, -height));
        walls.lineBy(P(0, height));
        walls.withStroke("default");
        graphic.addChild(walls);
        // Add filter layer.
        let filterLayer = new Path(Segments([[-radius, -1]], [[radius, -1]]));
        filterLayer.withStroke(2);
        filterLayer.strokeCap = 'butt';
        filterLayer.dashArray = [6, 3];
        graphic.addChild(filterLayer);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            pivot: P(0, 0),
            snapping: [
                filterLayer.topEdgeAsPlaceableSurface()
            ]
        };
    }
};
Sieve.properties = {
    label: "Sieve",
    defaultAppearance: {
        size: 75
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 50, max: 200,
        }
    ],
};
Sieve = __decorate([
    staticImplements()
], Sieve);
export { Sieve };
